import axios from './axios'
import { IMicroAreaAPIResponse, IMicroAreaFormDefault } from '../@types/refact/IMicroAreaAPI'

const getMicroAreasByAreaId = (areaId: number): Promise<IMicroArea[]> => {
    return axios.get<IMicroArea[]>(`/micro-areas?area_id=${areaId}`).then(({ data }) => {
        return data
    })
}

const getMicroAreasReasons = (): Promise<any[]> => {
    return axios.get('/micro-areas/reasons').then(({ data }) => {
        return data
    })
}

const getMicroAreasByFarmAndArea = (farmId: number, areaId: number): Promise<any[]> => {
    return axios.get('/micro-areas', {
        params: { farm_id: farmId, area_id: areaId }
    }).then(({ data }) => {
        return data
    })
}

const createMicroAreas = (data: any[]): Promise<any> => {
    return axios.post('/micro-areas', data).then(({ data }) => {
        return data
    })
}

const updateMicroAreas = (data: any[]): Promise<any> => {
    return axios.patch('/micro-areas', data).then(({ data }) => {
        return data
    })
}

const deleteMicroArea = (microAreaId: number): Promise<any> => {
    return axios.delete(`/micro-areas/${microAreaId}`).then(({ data }) => {
        return data
    })
}

const getMicroAreaByIdForForm = (microAreaId: number): Promise<IMicroAreaFormDefault> => {
    return axios.get(`/micro-areas/${microAreaId}`).then(({ data }) => {
        return {
            id: data.micro_area_id,
            initials: data.micro_area_initials,
            farm_id: data.farm_id,
            farm_initials: data.farm_initials,
            area_id: data.area_id,
            area_initials: data.area_initials,
            map_coords: data.micro_area_map_coords?.map((coord: any) => ({
                lat: coord.latitude,
                lng: coord.longitude,
            })) || [],
            reason_id: data.micro_area_reason_id,
            batch_initials: data.batch_initials,
            remaining_area: data.remaining_area + data.acreage,
            acreage: data.acreage?.toFixed(2),
        };
    })
}

export const microAreaService = {
    getMicroAreasByAreaId,
    getMicroAreasReasons,
    getMicroAreasByFarmAndArea,
    createMicroAreas,
    updateMicroAreas,
    deleteMicroArea,
    getMicroAreaByIdForForm
}